/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_History_SinceInputs */

const fr_vehicle_history_since = /** @type {(inputs: Vehicle_History_SinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`depuis`)
};

const en_vehicle_history_since = /** @type {(inputs: Vehicle_History_SinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`since`)
};

/**
* | output |
* | --- |
* | "since" |
*
* @param {Vehicle_History_SinceInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_history_since = /** @type {((inputs?: Vehicle_History_SinceInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_History_SinceInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_history_since(inputs)
	return en_vehicle_history_since(inputs)
});